import { render, staticRenderFns } from "./HighwayRestAreasLayer.vue?vue&type=template&id=558e4328&"
import script from "./HighwayRestAreasLayer.vue?vue&type=script&lang=js&"
export * from "./HighwayRestAreasLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports